import { useEffect } from "react";
import locale from "./useBeforeUnloadMessage.locale";
export default function useBeforeUnloadMessage(hasChangesRef, message = locale.HAS_UNSAVED_DATA) {
    useEffect(() => {
        const callback = (event) => {
            if (!hasChangesRef.current)
                return undefined;
            if (event) {
                event.preventDefault();
                event.returnValue = message;
            }
            return message;
        };
        window.addEventListener("beforeunload", callback);
        return () => {
            window.removeEventListener("beforeunload", callback);
        };
    }, []);
}
